import * as React from 'react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * Sonner toast wrapper — themed to match the admin token contract.
 * Mount once at the app root (apps/admin/src/main.tsx) and trigger via
 * `import { toast } from 'sonner'` in any component.
 */
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="light"
      richColors
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-bg group-[.toaster]:text-text group-[.toaster]:ring-1 group-[.toaster]:ring-black/5 group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-text-muted',
          actionButton:
            'group-[.toast]:bg-accent group-[.toast]:text-text-inverted',
          cancelButton:
            'group-[.toast]:bg-surface group-[.toast]:text-text-muted',
        },
      }}
      {...props}
    />
  );
}

export { toast } from 'sonner';
